function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 4.58331H11.125C8.84683 4.58331 7 6.43014 7 8.70831V8.70831C7 10.9865 8.84683 12.8333 11.125 12.8333H14.1042C16.2558 12.8333 18 14.5775 18 16.7291V16.7291C18 18.8808 16.2558 20.625 14.1042 20.625H7",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 0.916656V4.58332",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 21.3889V23.8333",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgDollar = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDollar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Dollar.3d28d28c.svg";
export { ForwardRef as ReactComponent };